import { ActionPersistSummary } from "@cervval.js/common-action/src/action.model";
import { TimestampTools } from "@cervval.js/common/tools";


// TODO: If WS_ROOM_PREFIX become too incremented, it should be interesting to create a structure withe the room name and some metadata attached to it
// in order to replace the current prefix usage 
export type RoomName = string;

/** message emitted when an action is executed and data have changed */
export type UpdateNotificationMessage = {
    /** Map of element type names and ids that were impacted (updated, deleted, created) */
    updates: Record<string, ActionPersistSummary>[],
    /** Server notification timestamp */
    ts: TimestampTools.UnixTimestamp
};

/** Server to client messages */
export type S2C = {
    /** message emitted when an action is executed and data have changed */
    "DATA_UPDATE": UpdateNotificationMessage,
    /** message emitted to current socket when there is a new user connection */
    "NEW_SOCKET": { appVersion: string },
    /** message emitted in USER_LIST room when there is a user connection / disconnection, if a user navigates or enters / leaves a room */
    "USER_LIST_CHANGE": void,
    /** message emitted in a room when room members change to be able to display current room members (emitted only in rooms starting with "!") */
    "ROOM_MEMBERS": { room: string, users: UserDisplayInfo[] },
    /** message emitted to all sockets of user when the user logs out */
    "LOGGED_OUT": void,
    /** message emitted to user when its session is terminated */
    "SESSION_TERMINATED": void
};

/** Client to server messages */
export type C2S = {
    /** message emitted when the application or the current page requests to enter or leave rooms  */
    "USER_ROOMS": { enterRooms?: string[], leaveRooms?: string[] },
    /** message emitted when user navigates to a new page */
    "USER_NAVIGATION": { page: string }
};

export enum Rooms {
    "USER_LIST" = "!USER_LIST",
    "ALL_DATA_UPDATES" = "ALL_DATA_UPDATES"
}

/** Prefixes to add on a room's name that activate functionalities */
export enum WS_ROOM_PREFIX {
    /** Allow all users in the room to be notified automatically when data are updated from someone in the room */
    AUTO_NOTIFICATION = "@",
    /** Allow all users in the room to be notified automatically when room members list change */
    ROOM_MEMBER_NOTIFICATION = "!"
}

/** UserDisplayInfo is sent to other users when room members need to be displayed */
export interface UserDisplayInfo {
    socketUid: string;
    displayName: string;
    avatarUrl?: string;
}

/**
 * User Connection Info corresponds to one "browser tab" of a user, it is identified by its socketUid
 */
export interface UserConnectionInfo {
    ip: string | undefined;
    userUid: string;
    displayInfo: UserDisplayInfo;
    serverInstanceUid: string;
    socketUid: string;
    sessionId: string;
    /** connection timestamp */
    connectTS: TimestampTools.UnixTimestamp;
    /** last visited page */
    page: string;
    /** last visited page navigation timestamp */
    navigationTS: TimestampTools.UnixTimestamp;
    /** 
     * rooms where user is registered 
     * BGS : we store the user's rooms in UserConnectionInfo and don't use socket.rooms because socket.rooms are cleared before on.disconnect is fired
     * which means we could not emit the ROOM_MEMBERS S2C MESSAGE messages on disconnect
     * */
    rooms: RoomName[];
}